import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function handleError(error, toast, forceTitle = null) {
  if (error.response && error.response.data) {
    const responseData = error.response.data
    let title = forceTitle
    let errorsList = null

    // Handle Laravel validation errors format: { "message": "...", "errors": { "field": ["error1", "error2"] } }
    if (responseData.errors && typeof responseData.errors === 'object') {
      // Use the message field as title, or default to "Validation Error"
      if (!title) {
        title = responseData.message || 'Validation Error'
      }
      // Flatten all error messages from the errors object
      errorsList = Object.keys(responseData.errors).flatMap(key => responseData.errors[key])
    } else if (responseData.message) {
      // Handle old format where message might be a string or object
      const messageData = responseData.message
      if (!title) {
        title = typeof messageData === 'string' ? messageData : 'Error'
      }
      // If message is an object, flatten its values
      if (typeof messageData === 'object') {
        errorsList = Object.keys(messageData).flatMap(key => messageData[key])
      }
    } else {
      title = forceTitle || 'Error'
    }

    toast({
      component: ToastificationContent,
      props: {
        title: title,
        errors: errorsList,
        icon: 'EditIcon',
        variant: 'danger',
      },
    })
  } else {
    toast({
      component: ToastificationContent,
      props: {
        title: typeof error === 'string' ? error : 'Encountered an unknown error.',
        icon: 'EditIcon',
        variant: 'danger',
      },
    })
  }
}
